"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhoneList = exports.initBase = void 0;
var countryTimezone = {};
var phoneList = [];
var initBase = function (config, errMsg) {
    countryTimezone = config;
    if (errMsg) {
        return Promise.resolve(errMsg);
    }
    return Promise.resolve();
};
exports.initBase = initBase;
var getPhoneList = function () {
    if (phoneList.length === 0) {
        var list = Object.entries(countryTimezone).map(function (_a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (_b = {},
                _b[key] = "+".concat(value.country_calling_code),
                _b);
        });
        return list;
    }
    return phoneList;
};
exports.getPhoneList = getPhoneList;
